class MaterialTableUtils {
    static getInsensitiveSortFunctionByAttribute( attribute ) {
        return (a, b) => {
            const aValue = a[attribute].toLowerCase();
            const bValue = b[attribute].toLowerCase();
            if ( aValue < bValue ) return -1;
            if ( aValue > bValue ) return 1;
            if ( aValue == bValue ) return 0;
        }
    }
}

export default MaterialTableUtils;